// @ts-nocheck
/* eslint-disable import/no-anonymous-default-export */
import { Subscriber, SubscriberEssential, SubscriberSimple } from 'apps/subscribers/models/subscriber';
import http from './http';
import { ActivityClass } from 'apps/activities/models/activity';
import { Order } from 'apps/orders/models/order';
import { Magazine } from 'apps/magazines/models/magazine';
import { TransferRequest } from 'apps/subscribers/models/transfer_request';
import { Message } from 'apps/messages/models/message';
import { Notification } from 'apps/messages/models/notification';
import { AlboUser } from 'apps/users/models/user';
import { University } from 'apps/university/models/university';
import { SistemaTSNotification } from 'apps/subscribers/models/sistema_ts';


class ApiService {

    // Login
    async login(formData) {
        let result = await http.post('login/', {...formData });
        return result;
    }

    // Logout
    async logout() {
        let result = await http.post('logout/');
        return result.data;
    }

    // Get Activities
    async getActivities() {
        let result = await http.get('activities/');       
        return result.data.map((data) => new ActivityClass(data));
    } 

    // Get Latest Activities
    async getLatestActivities() {
        let result = await http.get('latest-activities/');       
        return result.data.map((data) => new ActivityClass(data));
    } 

    // Filter Subscribers
    async filterSubscribers(formData) {
        let result = await http.post('filter-subscribers/', formData);
        return result.data.map((data) => new SubscriberSimple(data));
    }

    // Get Orders
    async getOrders() {
        let result = await http.get('orders/');       
        return result.data.map((data) => new Order(data));
    }

    // Get Order
    async getOrder(id) {
        let result = await http.get('orders/' + id);    
        return result.data;
    }

    // Create Order
    async createOrder(formData) {
        let result = await http.post('orders/', {...formData });
        return result;
    }

    // Edit Order
    async editOrder(id, formData) {
        let result = await http.patch('orders/' + id + '/', {...formData });
        return result;
    }

    // Delete Order
    async deleteOrder(id) {
        let result = await http.delete('orders/' + id + '/');
        return result;
    }

    // Get Magazines
    async getMagazines() {
        let result = await http.get('magazines/');       
        return result.data.map((data) => new Magazine(data));
    }

    // Get Magazine
    async getMagazine(id) {
        let result = await http.get('magazines/' + id);    
        return result.data;
    }
    
    // Create Magazine
    async createMagazine(formData) {
        let result = await http.post('magazines/', {...formData });
        return result;
    }

    // Edit Magazine
    async editMagazine(id, formData) {
        let result = await http.patch('magazines/' + id + '/', {...formData });
        return result;
    }

    // Delete Magazine
    async deleteMagazine(id) {
        let result = await http.delete('magazines/' + id + '/');
        return result;
    }

    // Get Subscriptions
    async getSubscriptions(subID) {
        let result = await http.get('subscribers/' + subID + '/subscriptions/');
        return result.data;
    }

    // Create Subscriber
    async createSubscriber(formData) {
        let result = await http.post('subscribers/', {...formData });
        return result;
    }

    // Get Subscribers
    async getSubscribers() {
        let result = await http.get('subscribers/');       
        return result.data.map((data) => new Subscriber(data));
    }

    // Get Subscribers List (Simple Data)
    async getSubscribersList() {
        let result = await http.get('subscribers-list/');       
        return result.data.map((data) => new SubscriberSimple(data));
    }

    // Get Subscribers By Order (Simple Data)
    async getSubscribersByOrder(order) {
        let result = await http.get('subscribers-by-order/' + order);       
        return result.data.map((data) => new SubscriberSimple(data));
    }

    // Get Subscribers with Residence Document
    async getSubscribersWithResidenceDocument() {
        let result = await http.get('subscribers-with-residence-document/');       
        return result.data.map((data) => new SubscriberSimple(data));
    } 

    // Get Subscriber
    async getSubscriber(fiscalCode) {
        let result = await http.get('subscribers/' + fiscalCode);       
        return result.data;
    }

    // Edit Subscriber
    async editSubscriber(fiscalCode, formData) {
        let result = await http.patch('subscribers/' + fiscalCode + '/', {...formData });
        return result;
    }

    // Delete Subscriber
    async deleteSubscriber(fiscal_code) {
        let result = await http.delete('subscribers/' + fiscal_code + '/');
        return result;
    }
 
    // Get Subscription
    async getSubscription(id) {
        let result = await http.get('subscriptions/' + id);       
        return result.data;
    } 

    // Edit Subscription
    async editSubscription(id, formData) {
        let result = await http.patch('subscriptions/' + id + '/', {...formData });
        return result;
    }

    // Create Subscription
    async createSubscription(formData) {
        let result = await http.post('subscriptions/', {...formData });
        return result;
    }

    // Delete Subscription
    async deleteSubscription(id) {
        let result = await http.delete('subscriptions/' + id + '/');
        return result;
    }

    //Upload File
    async uploadFile(file, source) {
        const formData = new FormData();

        switch(source) {

            default:
                formData.append("source", "standard");
        }
        
        formData.append("file", file);

        const filenameHeaderValue = 'inline;filename=' + encodeURIComponent(file.name);

        const result = await http.put('/file/upload/', formData, 
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Content-Disposition': filenameHeaderValue,
                    "Access-Control-Allow-Origin": "*"
                }
            }
        );
        return result.data;
    }

    // Get Transfer Requests
    async getTransferRequests() {
        let result = await http.get('transfer_requests/');       
        return result.data.map((data) => new TransferRequest(data));
    } 

    // Get Transfer Requests By Order
    async getTransferRequestsByOrder(order) {
        let result = await http.get('transfer-requests-by-order/' + order);       
        return result.data.map((data) => new TransferRequest(data));
    } 

    // Create Transfer Request
    async createTransferRequest(formData) {
        let result = await http.post('transfer_requests/', {...formData });
        return result;
    }

    // Edit Subscription
    async editTransferRequest(id, formData) {
        let result = await http.patch('transfer_requests/' + id + '/', {...formData });
        return result;
    }

    // Delete Transfer Request
    async deleteTransferRequest(id) {
        let result = await http.delete('transfer_requests/' + id + '/');
        return result;
    }

    // Get User Orders
    async getUserOrders(id_user) {
        let result = await http.get('user-orders-list/' + id_user);
        return result.data;
    }

    // Create User Order
    async createUserOrders(formData) {
        let result = await http.post('user_orders/', {...formData });
        return result;
    }

    // Edit User Orders
    async editUserOrders(id, formData) {
        let result = await http.patch('user_orders/' + id + '/', {...formData });
        return result;
    }

    // Delete User OrdersUser Orders
    async deleteUserOrders(id) {
        const result = await http.delete('user_orders/' + id + '/');
        return result;
    }

    // Get User Profile
    async getUserProfile() {
        let result = await http.get('user-profile/');
        return result.data;
    }

    // Get Order Messages
    async getOrderMessages() {
        let result = await http.get('messages/');       
        return result.data.map((data) => new Message(data));
    } 

    // Get Personal Messages
    async getPersonalMessages(order) {
        let result = await http.get('user-messages/');       
        return result.data.map((data) => new Message(data));
    } 

    // Send Message
    async sendMessage(formData) {
        let result = await http.post('messages/', {...formData });
        return result;
    }

    // Get Unread Notifications
    async getNotifications() {
        let result = await http.get('notifications/unread/'); 
        return result.data.map((data) => new Notification(data));
    }

    // Mark Notifications as read
    async setNotificationsAsSeen(unreadNotificationsIDs) {
        let result = await http.post('notifications/mark-as-read/', {
            notification_ids: unreadNotificationsIDs
        });
        return result;
    }

    // Get Users with the albo groups
    async getUsersAlbo() {
        let result = await http.get('users-albo-list/');       
        return result.data.map((data) => new AlboUser(data));
    }

    // Get Users without any group
    async getUsers() {
        let result = await http.get('users-list/');       
        return result.data.map((data) => new AlboUser(data));
    }

    // Edit Users Groups
    async editUsers(users) {        
        let result = await http.patch('users/update/', { users: users });
        return result;        
    }

    // Remove Albo Group
    async removeAlboGroup(users) {        
        let result = await http.patch('users/remove-albo-group/', { users: users });
        return result;        
    }

    // Get Universities
    async getUniversities() {
        let result = await http.get('universities/');       
        return result.data.map((data) => new University(data));
    }

    // Get University
    async getUniversity(id) {
        let result = await http.get('universities/' + id);    
        return result.data;
    }

    // Create University
    async createUniversity(formData) {
        let result = await http.post('universities/', {...formData });
        return result;
    }

    // Edit University
    async editUniversity(id, formData) {
        let result = await http.patch('universities/' + id + '/', {...formData });
        return result;
    }

    // Delete University
    async deleteUniversity(id) {
        let result = await http.delete('universities/' + id + '/');
        return result;
    }

    // Print Subscribers
    async printSubscribers(subscribers, page, printFilters) {
        let result = await http.post('print-subscribers/', {
            subscribers: subscribers,
            page: page,
            filters: printFilters
        }, {
            responseType: 'blob'
        });
        return result;
    }

    // Print Transfers
    async printTransfers(transfers, page, order_id, printFilters) {
        let result = await http.post('print-transfers/', {
            transfers: transfers,
            page: page,
            order_id: order_id,
            filters: printFilters
        }, {
            responseType: 'blob'
        });
        return result;
    }

    // Print Subscriber Profile
    async printSubscriberProfile(fiscalCode, printFilters) {
        let result = await http.post('print-subscriber-profile/', {
            fiscal_code: fiscalCode,
            filters: printFilters
        }, {
            responseType: 'blob'
        });
        return result;
    }

    // Get Subscribers With Last KO
    async getSubscribersWithLastKO() {
        let result = await http.get('subscribers-with-last-ko/');       
        return result.data.map((data) => new SistemaTSNotification(data));
    }

    // Retry Tessera
    async retryTessera(id) {
        let result = await http.post('retry-tessera/' + id + '/');
        return result.data;
    }

    // Get Subscribers Count
    async getSubscribersCount() {
        let result = await http.get('subscribers-count');
        return result.data;
    }

    // Export Albo
    async exportAlbo(printFilters) {        
        const result = await http.post('export-albo/', {
            filters: printFilters
        }, {
            responseType: 'blob'
        });
        return result;        
    }

    // Export Single Order
    async exportSingleOrder(printFilters, order) {        
        const result = await http.post('export-single-order/', {
            filters: printFilters,
            order: order
        }, {
            responseType: 'blob'
        });
        return result;        
    }

    // Get Max N Sub by Order
    async getMaxNSubByOrder(order) {
        let result = await http.get('max-nsub-by-order/' + order);       
        return result.data;
    }

    // Search Subscriber for Transfer
    async searchSubscriberForTransfer(formData) {
        let result = await http.post('subscriber-transfer/', formData);
        return result.data.map((data) => new SubscriberEssential(data));
    }
}

export default new ApiService();
